import { APIError } from "src/models/components/errorModel";
import { DeclarationTypes } from "./actionTypes";

export interface DeclarationInitialState {
loading: boolean,
error:APIError | any;
  declarationList: {
    totalCount: number,
    items: any
  },
message:string;
paginatorCount:number;
manufacturerList:any[];
declarationFormDetails:DeclarationFormDetails | null
}

export interface DeclarationFormDetails {
  id: number
  supplierName: string
  dcNumber: string
  type: string
  notes: string
  supplierAddress: string
  supplierContactPerson: string
  supplierMobile: string
  supplierEmail: string
  supplierGSTNumber: string
  isDeleted: boolean
  dcFormDetails: DcFormDetail[] | any;
}

export interface DcFormDetail {
  dcFormId: number
  defectSkus: string
  quantity: number
  unitPrice: number
  totalPrice: number
  remarks: string
  id: number
  isDeleted: boolean
}

const initialState: DeclarationInitialState = {
  loading: false,
  error: null,
  declarationList: {
    totalCount: 0,
    items: []
  },
  message:"",
  paginatorCount:0,
  manufacturerList:[],
  declarationFormDetails:null
}

const DeclarationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case DeclarationTypes.GET_DECLARATION_LOADING:
    case DeclarationTypes.GET_DECLARATION_BY_ID_LOADING:
    case DeclarationTypes.PRINT_DECLARATION_FORM_LOADING:
    case DeclarationTypes.CREATE_DECLARATION_FORM_LOADING:
    case DeclarationTypes.MAIL_DECLARATION_FORM_LOADING:
        return{
            ...state,
            loading:true
        }
    case DeclarationTypes.GET_DECLARATION_SUCCESS:
        return{
            ...state,
            loading:false,
            declarationList:{
                totalCount: action.payload.data.totalCount,
                items: action.payload.data.items
            },
            paginatorCount: action.payload.data.items.length
        }
    case DeclarationTypes.GET_MANUFACTURER_DROPDOWN_SUCCESS:
        return{
            ...state,
            manufacturerList:action.payload.data
        }
    case DeclarationTypes.GET_DECLARATION_BY_ID_SUCCESS:
        return{
            ...state,
            loading:false,
            declarationFormDetails:action.payload.data
        }
    case DeclarationTypes.CREATE_DECLARATION_FORM_SUCCESS:
        return{
            ...state,
            loading:false,
            message:action.payload
        }
    case DeclarationTypes.PRINT_DECLARATION_FORM_SUCCESS:
        return{
            ...state,
            loading:false,
        }
    case DeclarationTypes.MAIL_DECLARATION_FORM_SUCCESS:
        return{
            ...state,
            loading:false,
            message:"Mail sent successfully"
        }
    case DeclarationTypes.CLEAR_MESSAGE:

        return{
            ...state,
            message:"",
            error:"",
            loading:false
        }
    case DeclarationTypes.RESET_MESSAGE:

        return{
            ...state,
            message:"",
            error:"",
            loading:false,
            declarationFormDetails:null
        }
    case DeclarationTypes.GET_DECLARATION_FAIL:
    case DeclarationTypes.GET_DECLARATION_BY_ID_FAIL:
    case DeclarationTypes.CREATE_DECLARATION_FORM_FAIL:
    case DeclarationTypes.PRINT_DECLARATION_FORM_FAIL:
    case DeclarationTypes.MAIL_DECLARATION_FORM_FAIL:
        return{
            ...state,
            loading:false,
            error: action.payload
        }
    default:
        return{
            ...state
        }
  }
}

export default DeclarationReducer;